export default "__VITE_ASSET__7f283e8b__"